// tokenUtils.js
import axios from "axios";

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");

  if (!refreshToken) throw new Error("No refresh token");

  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/token/refresh/`, // Use full URL if axios has no baseURL
    {
      refresh: refreshToken,
    }
  );

  const newAccessToken = response.data.access;
  localStorage.setItem("accessToken", newAccessToken);
  return newAccessToken;
};
